import React from 'react';

export const Lightbulb = ({
  className,
  color,
  height,
  width,
}: {
  className?: string;
  color?: string;
  height?: string;
  width?: string;
}) => (
  <svg
    width="18"
    height="24"
    viewBox="0 0 18 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 23.348C8.35833 23.348 7.80922 23.1197 7.35267 22.6632C6.89533 22.2058 6.66667 21.6563 6.66667 21.0147H11.3333C11.3333 21.6563 11.1051 22.2058 10.6485 22.6632C10.1912 23.1197 9.64167 23.348 9 23.348ZM4.33333 19.848V17.5147H13.6667V19.848H4.33333ZM4.625 16.348C3.28333 15.5508 2.21894 14.4813 1.43183 13.1396C0.643944 11.798 0.25 10.3396 0.25 8.76465C0.25 6.33409 1.10089 4.26832 2.80267 2.56732C4.50367 0.865538 6.56944 0.0146484 9 0.0146484C11.4306 0.0146484 13.4963 0.865538 15.1973 2.56732C16.8991 4.26832 17.75 6.33409 17.75 8.76465C17.75 10.3396 17.3564 11.798 16.5693 13.1396C15.7814 14.4813 14.7167 15.5508 13.375 16.348H4.625ZM5.325 14.0146H12.675C13.55 13.3924 14.2259 12.6244 14.7027 11.7105C15.1787 10.7966 15.4167 9.81465 15.4167 8.76465C15.4167 6.97576 14.7944 5.45909 13.55 4.21465C12.3056 2.9702 10.7889 2.34798 9 2.34798C7.21111 2.34798 5.69444 2.9702 4.45 4.21465C3.20556 5.45909 2.58333 6.97576 2.58333 8.76465C2.58333 9.81465 2.82172 10.7966 3.2985 11.7105C3.7745 12.6244 4.45 13.3924 5.325 14.0146Z"
      fill={color || '#BF2600'}
    />
  </svg>
);
